import { useRecoilValue } from 'recoil';
import { BoardType, Units } from 'Types';

import BoardBase from 'boardClasses/BoardBase';
import { createBoard, getCtor } from 'boardClasses/BoardFactory';
import {
  boardInstanceAtomFamily,
  routerMatchAtom,
  selectedBoardIDAtom,
  workingBoardInstanceAtomFamily,
} from 'state/recoilState';

export const useSelectedBoardInstance = (): BoardBase<BoardType> | null => {
  const selectedBoardID = useRecoilValue(selectedBoardIDAtom);
  const selectedBoard = useRecoilValue(
    boardInstanceAtomFamily(selectedBoardID)
  );
  const workingSelectedBoard = useRecoilValue(
    workingBoardInstanceAtomFamily(selectedBoardID)
  );

  const match = useRecoilValue(routerMatchAtom);

  if (
    (match.path === '/designer/hash/:boardHash' ||
      match.path === '/build_steps/hash/:boardHash') &&
    match.isExact
  ) {
    const randomBoardHash = match.params.boardHash;
    const { type, id, name, params, units } = JSON.parse(atob(randomBoardHash));
    return createBoard(getCtor(type), id, name, params, units);
  }

  return selectedBoardID == null
    ? null
    : workingSelectedBoard ?? selectedBoard ?? null;
};

export const useSelectedBoardStep = () => {
  const selectedBoard = useSelectedBoardInstance();

  if (selectedBoard?.units === Units.MM) {
    return 1;
  }

  return 1 / 8;
};
